<template>
    <div class="devices-list__block" v-if="deviceData">
        <device-status :device="deviceData" :showLocation="showLocation"/>
        <v-layout row class="devices-list__block__title">
            <device-title :device="deviceData"></device-title>
            <v-flex class="btn-block">
                <device-favorite :device="deviceData"></device-favorite>
            </v-flex>
        </v-layout>
        <div class="main-text btn-grey mt-3" @click="openRemote">
            Открыть пульт
        </div>
    </div>
</template>

<script>
export default {
    name: "TVDevice",
    props: {
        device: {
            type: [Array, Object],
            default: null,
        },
        showLocation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            deviceData: {},
        };
    },
    created() {
        this.deviceData = this.device;
    },
    watch: {
        device(val) {
            if (val) {
                this.deviceData = val;
            }
        },
    },
    methods: {
        openRemote() {
            this.$router.push({ name: 'deviceTV', params: { device: this.deviceData.uid } });
        }
    },
}
</script>